import { type ComponentProps, memo } from "react";

import { Image as HydrogenImage } from "@shopify/hydrogen-react";

type Props =
  | (ComponentProps<typeof HydrogenImage> & {
      fetchpriority?: "high" | "low" | "auto";
    })
  | undefined;

const ImageBase = (props: Props) => {
  if (!props) {
    return null;
  }

  return <HydrogenImage {...props} />;
};

export const Image = memo(ImageBase);
